import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatLuxonDateModule,
  LuxonDateAdapter,
  MAT_LUXON_DATE_FORMATS,
  MAT_LUXON_DATE_ADAPTER_OPTIONS
} from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { LayoutModule } from '@angular/cdk/layout';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';

const materialModules = [
  MatExpansionModule,
  MatTableModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatSidenavModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatLuxonDateModule,
  MatMenuModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSnackBarModule,
  MatTableModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule,
  OverlayModule,
  LayoutModule,
  TextFieldModule
];

@NgModule({
  declarations: [],
  imports: [CommonModule, ...materialModules],
  exports: [CommonModule, ...materialModules],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'default' },
    { provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS }
  ]
})
export class SharedMaterialModule {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.addSvgIcon({ name: 'person', url: 'assets/icons/person.svg' });
    this.addSvgIcon({ name: 'visibility', url: 'assets/icons/visibility.svg' });
    this.addSvgIcon({ name: 'visibility_off', url: 'assets/icons/visibility_off.svg' });
    this.addSvgIcon({ name: 'delete', url: 'assets/icons/delete.svg' });
    this.addSvgIcon({ name: 'search', url: 'assets/icons/search.svg' });
    this.addSvgIcon({ name: 'content_copy', url: 'assets/icons/content_copy.svg' });
    this.addSvgIcon({ name: 'edit', url: 'assets/icons/edit.svg' });
    this.addSvgIcon({ name: 'double_arrow_up', url: 'assets/icons/keyboard_double_arrow_up.svg' });
    this.addSvgIcon({ name: 'double_arrow_down', url: 'assets/icons/keyboard_double_arrow_down.svg' });
    this.addSvgIcon({ name: 'more_vert', url: 'assets/icons/more_vert.svg' });
    this.addSvgIcon({ name: 'arrow_forward', url: 'assets/icons/arrow_forward_ios.svg' });
    this.addSvgIcon({ name: 'arrow_back', url: 'assets/icons/arrow_back_ios.svg' });
    this.addSvgIcon({ name: 'view_back', url: 'assets/icons/view_back.svg' });
    this.addSvgIcon({ name: 'view_bottom', url: 'assets/icons/view_bottom.svg' });
    this.addSvgIcon({ name: 'view_front', url: 'assets/icons/view_front.svg' });
    this.addSvgIcon({ name: 'view_left', url: 'assets/icons/view_left.svg' });
    this.addSvgIcon({ name: 'view_right', url: 'assets/icons/view_right.svg' });
    this.addSvgIcon({ name: 'view_top', url: 'assets/icons/view_top.svg' });
    this.addSvgIcon({ name: 'view_topleft', url: 'assets/icons/view_topleft.svg' });
    this.addSvgIcon({ name: 'view_topright', url: 'assets/icons/view_topright.svg' });
    this.addSvgIcon({ name: 'content_paste', url: 'assets/icons/content_paste.svg' });
    this.addSvgIcon({ name: 'info', url: 'assets/icons/info.svg' });
    this.addSvgIcon({ name: 'warning', url: 'assets/icons/warning.svg' });
    this.addSvgIcon({ name: 'error', url: 'assets/icons/error.svg' });
    this.addSvgIcon({ name: 'help_outline', url: 'assets/icons/help_outline.svg' });
    this.addSvgIcon({ name: 'undo', url: 'assets/icons/undo.svg' });
    this.addSvgIcon({ name: 'drag_pan', url: 'assets/icons/drag_pan.svg' });
    this.addSvgIcon({ name: 'check', url: 'assets/icons/check.svg' });
    this.addSvgIcon({ name: 'preview', url: 'assets/icons/preview.svg' });
    this.addSvgIcon({ name: 'close', url: 'assets/icons/close.svg' });
  }

  private addSvgIcon({ name, url }) {
    this.matIconRegistry.addSvgIcon(name, this.domSanitizer.bypassSecurityTrustResourceUrl(url));
  }
}
